import styled from "styled-components";
import { Link } from "react-router-dom";
import { colors } from "../../styles/colors";
import { textStyles } from "../../styles/typography";

export const FooterSection = styled("footer")`
  background: ${colors.background.secondary};
  padding: 2.5rem 0;

  @media (max-width: 890px) {
    padding: 1.5rem 0;
  }
`;

export const Extra = styled("section")`
  background: ${colors.background.secondary};
  position: relative;
  width: 100%;
  overflow-x: hidden;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 2rem;

  @media (max-width: 890px) {
    padding-bottom: 1rem;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  ${textStyles.caption}
  color: ${colors.text.secondary};
  width: 70%;

  @media (max-width: 890px) {
    width: 90%;
  }
`;

export const Large = styled(Link)`
  ${textStyles.body("small")}
  color: ${colors.text.secondary};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-transform: capitalize;
  display: block;
  margin-bottom: 0.625rem;
  transition: all 0.3s ease-in-out;
  max-width: max-content;
  text-decoration: none;
  outline: none;

  &:hover {
    color: ${colors.text.secondary};
    text-underline-position: under;
    text-decoration: ${colors.text.secondary} underline;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

export const Chat = styled("p")`
  color: ${colors.text.secondary};
  max-width: fit-content;
  border-bottom: 1px solid ${colors.text.secondary};
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    border-bottom: 1px solid ${colors.text.secondary};
    color: ${colors.text.secondary};
  }
`;

export const FooterContainer = styled("div")`
  max-width: fit-content;
  width: auto;
  display: flex;
  justify-content: flex-end;
  text-align: center;
  align-items: center;
  gap: 1rem;
  transition: all 0.1s ease-in-out;
  overflow: hidden;
  min-width: 0;
  flex: 0 0 auto;

  a {
    min-width: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover,
    &:active,
    &:focus {
      -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
      transform: scale(1.1);
    }
  }

    @media (max-width: 890px) {
    max-width: 100%;
    justify-content: flex-end;
    gap: 0.8rem;
    width: auto;

    a:not(:last-child) {
      display: none;
    }
  }

  div {
    cursor: pointer;
    width: 25px;
    height: 25px;

    &:hover {
      fill: ${colors.text.secondary};
    }
  }
`;

export const Language = styled("h5")`
  text-transform: capitalize;
  color: ${colors.text.secondary};

    @media (max-width: 890px) {
    padding: 1.5rem 0;
  }
`;

export const Label = styled("label")`
  ${textStyles.heading("h5")}
  text-transform: capitalize;
  color: ${colors.text.secondary};
  display: block;
  margin-bottom: 1rem;

    @media (max-width: 890px) {
    padding: 1.5rem 0;
    margin-bottom: 1rem;
  }
`;

export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 85px;
  overflow: hidden;
`;
